t = require('views/internal/teacup-with-helpers')('header_add_menu')

module.exports = t.renderable ({ upsellEnabled }) ->
  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-new-board', { href: '#' }, ->
        t.format 'create-board'
        t.text ' '
        t.span '.sub-name', ->
          t.format 'a-board-is-made-up-of-cards-ordered-on-lists'

    t.li ->
      t.a '.js-new-org', { href: '#' }, ->
        t.format 'create-team'
        t.text ' '
        t.span '.sub-name', ->
          t.format 'a-team-is-a-group-of-boards-and-people'

    if upsellEnabled
      t.li ->
        t.a '.js-new-bc-org', { href: '#' }, ->
          t.format 'create-business-team'
          t.text ' '
          t.span '.sub-name', ->
            t.format 'with-business-class-your-team-has-more'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_add_menu.coffee